import { render, staticRenderFns } from "./DriverModal.vue?vue&type=template&id=244e4019&scoped=true&"
import script from "./DriverModal.vue?vue&type=script&lang=ts&"
export * from "./DriverModal.vue?vue&type=script&lang=ts&"
import style0 from "./DriverModal.vue?vue&type=style&index=0&id=244e4019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e4019",
  null
  
)

export default component.exports